import { TTalentComment } from "@/api/entities/talent-comment.entity";
import { MONTH_DATE_FORMAT_WITH_TIMES } from "@/constants/datetime";
import { UiComment } from "@/features/talent/types/talentCommentForm";
import dayjs from "dayjs";

export const transformComments = (apiData: TTalentComment[] = [], currentUserId: number): UiComment[] => {
  return apiData.map((item) => ({
    name: item.user.fullName,
    text: item.commentText,
    time: dayjs(item.createdAt).format(MONTH_DATE_FORMAT_WITH_TIMES),
    isOwn: Number(item.userId) === currentUserId,
  }));
};
